import NetworkService, { Endpoint } from './NetworkService'

export default class BlogService {
  network
  constructor() {
    this.network = new NetworkService()
  }
  list(params: any = {}) {
    return this.network.get(Endpoint.blogPosts, params)
  }
}
